import React from "react"

import Modal from "./Modal"

export interface Props {
  children: React.ReactNode
  isOpen: boolean
  name?: string
  onClose: () => void
}

export interface ComponentProps extends Props {}

export default Modal
